import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectSessionAdvisor } from '../model/selectors';
import {
  fetchClientsForAdvisorByAdvisorIdRequest,
  fetchSubordinateAdvisorsByAdvisorIdRequest,
} from '..';

import AdvisorDashboardShell from '../components/AdvisorDashboardShell';

export function AdvisorDashboard({ advisorId }: AdvisorIdProps) {
  const advisor = useSelector(selectSessionAdvisor);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fetchClientsForAdvisorByAdvisorIdRequest({
        advisorId: advisor.advisorId,
        isInvalidation: false,
      }),
    );
    dispatch(
      fetchSubordinateAdvisorsByAdvisorIdRequest({
        advisorId: advisor.advisorId,
      }),
    );
  }, [dispatch, advisor.advisorId]);

  return <AdvisorDashboardShell />;
}
